var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftAndRightArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 42,
    viewBox: "0 0 66 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    width: 20,
    height: 20,
    rx: 3,
    fill: "black",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8184 5.39311C32.89 5.23826 33.11 5.23826 33.1816 5.39311L36.333 12.2161C36.3942 12.3487 36.2974 12.5 36.1514 12.5H29.8486C29.7026 12.5 29.6058 12.3487 29.667 12.2161L32.8184 5.39311Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 22,
    width: 20,
    height: 20,
    rx: 3,
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1816 36.6069C33.11 36.7617 32.89 36.7617 32.8184 36.6069L29.667 29.7839C29.6058 29.6513 29.7026 29.5 29.8486 29.5H36.1514C36.2974 29.5 36.3942 29.6513 36.333 29.7839L33.1816 36.6069Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.9238,
    y: 22,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6069 31.8184C60.7617 31.89 60.7617 32.11 60.6069 32.1816L53.7839 35.333C53.6513 35.3942 53.5 35.2974 53.5 35.1514V28.8486C53.5 28.7026 53.6513 28.6058 53.7839 28.667L60.6069 31.8184Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    transform: "matrix(-1 0 0 1 20 22)",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39311 32.1816C5.23826 32.11 5.23826 31.89 5.39311 31.8184L12.2161 28.667C12.3487 28.6058 12.5 28.7026 12.5 28.8486V35.1514C12.5 35.2974 12.3487 35.3942 12.2161 35.333L5.39311 32.1816Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAndRightArrows);
export default __webpack_public_path__ + "static/media/LeftAndRightArrows.7acdb2c8db615e8fced8c86e2f660e6b.svg";
export { ForwardRef as ReactComponent };